<template>
  <div class="min-h-screen">
    <Toast />
    <RouterView v-if="isUserLoaded" />
  </div>
</template>

<script setup>
import { useUserStore } from './store/userStore'
import { setupHooks } from './router/router'
import {
  useRoute,
  useRouter
} from 'vue-router/composables'
import { ref } from 'vue'
import { getHomeRoute } from './lib/getHomeRoute'
import { usePermissions } from './composables/permissions'
import { useNotification } from './composables/notification'

const userStore = useUserStore()
const { canAccessPage } = usePermissions()
const { showWarning } = useNotification()
const router = useRouter()
const route = useRoute()

const isUserLoaded = ref(false)

const loadCurrentUser = async () => {
  try {
    await userStore.getCurrentUser()

    const homeRoute = getHomeRoute(userStore.currentUser.roles)
    const canStayOnCurrentPage = canAccessPage(route)

    if (route.name === 'auth:login' || !canStayOnCurrentPage) {
      await router.replace(homeRoute)

      if (!canStayOnCurrentPage) {
        showWarning('You do not have permissions to access this page', {
          summary: 'Access Denied',
        })
      }
    }
  } finally {
    setupHooks()
    isUserLoaded.value = true
  }
}

router.onReady(loadCurrentUser)
</script>
